function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.154,
    height: 17.525,
    viewBox: "0 0 16.154 17.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 15",
    transform: "translate(4.586 2.535)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M7.172 4.136 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 155",
    d: "M17.344 13.157V6.782a1.594 1.594 0 0 0-.8-1.379l-5.575-3.187a1.594 1.594 0 0 0-1.594 0L3.8 5.4A1.594 1.594 0 0 0 3 6.782v6.375a1.594 1.594 0 0 0 .8 1.379l5.578 3.188a1.594 1.594 0 0 0 1.594 0l5.578-3.188a1.594 1.594 0 0 0 .794-1.379z",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    transform: "translate(-2 -1.227)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 156",
    d: "m3.27 6.96 6.957 4.024 6.957-4.024",
    transform: "translate(-2.055 -2.234)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 16",
    transform: "translate(8.172 8.742)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 8.033V0"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders_icon.2184d046970b9919c04a70f3b44867ed.svg";
export { ForwardRef as ReactComponent };